import { render } from "./AppThemeSwitcher.vue?vue&type=template&id=21c9ddcc&scoped=true"
import script from "./AppThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./AppThemeSwitcher.vue?vue&type=script&lang=js"

import "./AppThemeSwitcher.vue?vue&type=style&index=0&id=21c9ddcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c9ddcc"]])

export default __exports__